export default __webpack_public_path__ + "assets/webgl/picking-1.63589722.glb";